// extracted by mini-css-extract-plugin
module.exports = {"link":"_1410bfd27b--link--X9a5a","content":"_1410bfd27b--content--aV_Pt"};